import { AccountVerificationWizard } from '@identity/presentation/components/specific';
import { IdentityFlowProvider } from '@identity/presentation/context';

/**
 * The only route of the verification wizard.
 *
 * It checks nothing before rendering: its credential is the Parrot session, and the private route
 * already redirects to the login when there is none.
 *
 * The page declares its own flow because it is the entry point of one, and because a test mounts it
 * on its own.
 */
export const AccountVerificationPage = () => (
  <IdentityFlowProvider flow="verifyAccount">
    <AccountVerificationWizard />
  </IdentityFlowProvider>
);
